import { render, staticRenderFns } from "./ProviderForm.vue?vue&type=template&id=31a1046e"
import script from "./ProviderForm.vue?vue&type=script&lang=ts"
export * from "./ProviderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports